export const DEFAULT_SORT_ITEMS = [
  { column: "created", text: "Newest to oldest", desc: true },
  { column: "created", text: "Oldest to newest", desc: false },
  { column: "title", text: "Sort A to Z", desc: false },
  { column: "title", text: "Sort Z to A", desc: true },
];
